import { render, staticRenderFns } from "./ProsecutionFeeForm.vue?vue&type=template&id=d510a232&"
import script from "./ProsecutionFeeForm.vue?vue&type=script&lang=js&"
export * from "./ProsecutionFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports